/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as SignupRouteImport } from './routes/signup'
import { Route as ConfirmRouteImport } from './routes/confirm'
import { Route as CheckoutRouteImport } from './routes/checkout'
import { Route as CartRouteImport } from './routes/cart'
import { Route as AnalyzingRouteImport } from './routes/analyzing'
import { Route as AdminRouteImport } from './routes/admin'
import { Route as IndexRouteImport } from './routes/index'
import { Route as QuoteIdRouteImport } from './routes/quote.$id'
import { Route as OrderIdRouteImport } from './routes/order.$id'
import { Route as AdminOnboardingRouteImport } from './routes/admin_.onboarding'

const SignupRoute = SignupRouteImport.update({
  id: '/signup',
  path: '/signup',
  getParentRoute: () => rootRouteImport,
} as any)
const ConfirmRoute = ConfirmRouteImport.update({
  id: '/confirm',
  path: '/confirm',
  getParentRoute: () => rootRouteImport,
} as any)
const CheckoutRoute = CheckoutRouteImport.update({
  id: '/checkout',
  path: '/checkout',
  getParentRoute: () => rootRouteImport,
} as any)
const CartRoute = CartRouteImport.update({
  id: '/cart',
  path: '/cart',
  getParentRoute: () => rootRouteImport,
} as any)
const AnalyzingRoute = AnalyzingRouteImport.update({
  id: '/analyzing',
  path: '/analyzing',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminRoute = AdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const QuoteIdRoute = QuoteIdRouteImport.update({
  id: '/quote/$id',
  path: '/quote/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const OrderIdRoute = OrderIdRouteImport.update({
  id: '/order/$id',
  path: '/order/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminOnboardingRoute = AdminOnboardingRouteImport.update({
  id: '/admin_/onboarding',
  path: '/admin/onboarding',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/admin': typeof AdminRoute
  '/analyzing': typeof AnalyzingRoute
  '/cart': typeof CartRoute
  '/checkout': typeof CheckoutRoute
  '/confirm': typeof ConfirmRoute
  '/signup': typeof SignupRoute
  '/admin/onboarding': typeof AdminOnboardingRoute
  '/order/$id': typeof OrderIdRoute
  '/quote/$id': typeof QuoteIdRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/admin': typeof AdminRoute
  '/analyzing': typeof AnalyzingRoute
  '/cart': typeof CartRoute
  '/checkout': typeof CheckoutRoute
  '/confirm': typeof ConfirmRoute
  '/signup': typeof SignupRoute
  '/admin/onboarding': typeof AdminOnboardingRoute
  '/order/$id': typeof OrderIdRoute
  '/quote/$id': typeof QuoteIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/admin': typeof AdminRoute
  '/analyzing': typeof AnalyzingRoute
  '/cart': typeof CartRoute
  '/checkout': typeof CheckoutRoute
  '/confirm': typeof ConfirmRoute
  '/signup': typeof SignupRoute
  '/admin_/onboarding': typeof AdminOnboardingRoute
  '/order/$id': typeof OrderIdRoute
  '/quote/$id': typeof QuoteIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/admin'
    | '/analyzing'
    | '/cart'
    | '/checkout'
    | '/confirm'
    | '/signup'
    | '/admin/onboarding'
    | '/order/$id'
    | '/quote/$id'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/admin'
    | '/analyzing'
    | '/cart'
    | '/checkout'
    | '/confirm'
    | '/signup'
    | '/admin/onboarding'
    | '/order/$id'
    | '/quote/$id'
  id:
    | '__root__'
    | '/'
    | '/admin'
    | '/analyzing'
    | '/cart'
    | '/checkout'
    | '/confirm'
    | '/signup'
    | '/admin_/onboarding'
    | '/order/$id'
    | '/quote/$id'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AdminRoute: typeof AdminRoute
  AnalyzingRoute: typeof AnalyzingRoute
  CartRoute: typeof CartRoute
  CheckoutRoute: typeof CheckoutRoute
  ConfirmRoute: typeof ConfirmRoute
  SignupRoute: typeof SignupRoute
  AdminOnboardingRoute: typeof AdminOnboardingRoute
  OrderIdRoute: typeof OrderIdRoute
  QuoteIdRoute: typeof QuoteIdRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/signup': {
      id: '/signup'
      path: '/signup'
      fullPath: '/signup'
      preLoaderRoute: typeof SignupRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/confirm': {
      id: '/confirm'
      path: '/confirm'
      fullPath: '/confirm'
      preLoaderRoute: typeof ConfirmRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/checkout': {
      id: '/checkout'
      path: '/checkout'
      fullPath: '/checkout'
      preLoaderRoute: typeof CheckoutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/cart': {
      id: '/cart'
      path: '/cart'
      fullPath: '/cart'
      preLoaderRoute: typeof CartRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/analyzing': {
      id: '/analyzing'
      path: '/analyzing'
      fullPath: '/analyzing'
      preLoaderRoute: typeof AnalyzingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin': {
      id: '/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AdminRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/quote/$id': {
      id: '/quote/$id'
      path: '/quote/$id'
      fullPath: '/quote/$id'
      preLoaderRoute: typeof QuoteIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/order/$id': {
      id: '/order/$id'
      path: '/order/$id'
      fullPath: '/order/$id'
      preLoaderRoute: typeof OrderIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin_/onboarding': {
      id: '/admin_/onboarding'
      path: '/admin/onboarding'
      fullPath: '/admin/onboarding'
      preLoaderRoute: typeof AdminOnboardingRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AdminRoute: AdminRoute,
  AnalyzingRoute: AnalyzingRoute,
  CartRoute: CartRoute,
  CheckoutRoute: CheckoutRoute,
  ConfirmRoute: ConfirmRoute,
  SignupRoute: SignupRoute,
  AdminOnboardingRoute: AdminOnboardingRoute,
  OrderIdRoute: OrderIdRoute,
  QuoteIdRoute: QuoteIdRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
